import React from "react";
// import { Text } from '@/components'
import { Typography } from "@mui/material";
import domtoimage from "dom-to-image";

function ConfirmationReceipt({
  tx_ref,
  name,
  examCode,
  email,
  examName,
  price,
  noOfCandidates,
}) {
  const receiptSnapshot = async (id, name) => {
    const image = document.getElementById(id);
    const rcptUrl = new Image();

    rcptUrl.src = await domtoimage.toPng(image, { cacheBust: true });
    let downloadLink = document.createElement("a");
    downloadLink.href = rcptUrl.src;
    downloadLink.download = `${name}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  return (
    <div className="card-body ">
      <div
        id={"receipt"}
        style={{ backgroundColor: "white", padding: "10px 10px" }}
      >
        <Typography
          fontWeight="bold"
          fontSize="24px"
          align="center"
          className="mx-auto"
          marginBottom={2}
        >
          Payment validation with CBS ongoing!
        </Typography>

        {/* <h3 className='text-center'>{email}</h3> */}
        <div
          className="row"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ "margin-top": "5px", "margin-bottom": "20px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <p style={{ fontSize: "18px", display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
              {
                "Check the Payment Details Tab on this Requisition Form to query the status of this payment, print your receipt and generate your unique exam code"
              }
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }} >
            <div
              className="col-xl-6"
              style={{ "margin-top": "5px", "margin-bottom": "5px", }}
            >
              <p style={{ fontSize: "18px" }}>
                Name: <span style={{ fontWeight: "bold", textTransform: 'capitalize' }}>{name}</span>
              </p>
            </div>

            <div
              className="col-xl-6 my-3"
              style={{ "margin-top": "5px", "margin-bottom": "5px" }}
            >
              <p style={{ fontSize: "18px" }}>
                Bill No: <span style={{ fontWeight: "bold" }}> {tx_ref} </span>
              </p>
            </div>
            {/* <div
            className="col-xl-6 my-3"
            style={{ "margin-top": "5px", "margin-bottom": "5px" }}
          >
            <p style={{ fontSize: "18px" }}>
              Exam: <span style={{ fontWeight: "bold" }}> {examName} </span>
            </p>
          </div> */}

            <div
              className="col-xl-6 my-3"
              style={{ "margin-top": "5px", "margin-bottom": "5px" }}
            >
              <p style={{ fontSize: "18px" }}>
                Date/Time:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {" "}
                  {new Date().toDateString()} {" "}|{" "}
                  {new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}
                </span>
              </p>
            </div>

            <div
              className="col-xl-6 my-3"
              style={{ "margin-top": "5px", "margin-bottom": "5px" }}
            >
              <p className="float-end fw-bold" style={{ fontSize: "18px" }}>
                Amount: <span style={{ fontWeight: "bold" }}>{price}</span>{" "}
              </p>
            </div>

          </div>


        </div>

        {/* <div className="row">
                    <div className="col-xl-6" style={{ "margin-top": "5px", "margin-bottom": "5px" }}  >
                        <p style={{ fontSize: '18px' }}  >Candidate(s): <span style={{ fontWeight: 'bold' }}  >{noOfCandidates}</span></p>
                    </div>
                  
                    <hr />
                </div> */}

        <div className="text-center" style={{ "margin-top": "50px" }}>
          <p
            style={{
              fontSize: "14px",
              marginBottom: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {" "}
            © Payment Confirmation{" "}
          </p>

          {/* <a><u className="text-info">View in browser</u></a> */}
          <p
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Copyright © 2022 Sterling Tech. All rights reserved.{" "}
          </p>
        </div>
      </div>
      {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                <button  onClick={() => receiptSnapshot('receipt', "payment-rcpt")} >download</button>
            </div> */}
    </div>
  );
}

export default ConfirmationReceipt;
